const languages = [
    {
        name: 'PHP',
        documentationURL: 'https://www.php.net/'
    },
    {
        name: 'JavaScript',
        documentationURL: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript'
    },
    {
        name: 'Python',
        documentationURL: 'https://docs.python.org/3/'
    },
    {
        name: 'SQL',
        documentationURL: ''
    }
];

export default languages;